export function exportToCalendar({ title, description, location, startDate, endDate }) {
    const icsContent = `
BEGIN:VCALENDAR
VERSION:2.0
BEGIN:VEVENT
CLASS:PUBLIC
SUMMARY;LANGUAGE=en-us:${title}
DESCRIPTION:${description}
LOCATION:${location}
TRANSP:TRANSPARENT
DTSTART:${startDate}
DTEND:${endDate}
END:VEVENT
END:VCALENDAR
`.trim();

    const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${title.replace(/\s+/g, '_')}.ics`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export function attachCalendarButtons() {
    document.querySelectorAll('.add-to-calendar-btn').forEach(btn => {
        btn.addEventListener('click', function() {
            const el = this;
            exportToCalendar({
                title: el.dataset.title,
                description: el.dataset.description,
                location: el.dataset.location,
                startDate: el.dataset.start,
                endDate: el.dataset.end
            });
        });
    });
}
